<template>
  <v-card v-if="loading === false" width="100%" class="ml-7">
    <v-card-title>
      {{ serviceName }} - API ključ
    </v-card-title>

    <v-card-text v-if="company[companyApiInfoPropertyName] === null">
        Nije dostupno.
    </v-card-text>
    <v-card-text v-else>
      <v-row>
        <v-col cols="12" md="12" class="ma-0 pa-0">
           <v-list dense>
            <v-list-item>
              <v-list-item-icon>
                <v-icon> mdi-key </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Produkcioni API ključ</v-list-item-title>
                <v-list-item-subtitle> {{ company[companyApiInfoPropertyName].prodApiKey }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-icon>
                <v-icon> mdi-key </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Demo API ključ</v-list-item-title>
                <v-list-item-subtitle> {{ company[companyApiInfoPropertyName].demoApiKey }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>

      <v-row class="ma-0 pa-0">
        <v-col cols="12" md="6" class="ma-0 pa-0">
           <v-switch hide-details="auto" disabled class="disable-events" label="Demo SEF?" :input-value="company[companyApiInfoPropertyName].isDemo"></v-switch>
        </v-col>

        <v-col cols="12" md="6" class="mt-4 mb-0 pa-0">
          <v-chip text-color="white" :color="companyApiKeyValidatedColor">
            {{ companyApiKeyValidatedTextValue }}
          </v-chip>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <edit-company-api-key-dialog
        :company="company"
        :companyApiInfoPropertyName="companyApiInfoPropertyName"
        :serviceName="serviceName"
        v-if="loading === false && company[companyApiInfoPropertyName] !== null"
        @update="updateParentComponent"
      />

      <add-company-api-key-dialog
        v-else
        v-bind:companyId="company.id"
        v-bind:serviceName="serviceName"
        @updateCompany="updateParentComponent"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import EditCompanyApiKeyDialog from './EditCompanyApiKeyDialog.vue';
import AddCompanyApiKeyDialog from '../components/AddCompanyApiKeyDialog.vue';

import * as utils from '../utils.js';

export default {
  name: 'CompanyApiKeyDetails',
  components: {
    EditCompanyApiKeyDialog,
    AddCompanyApiKeyDialog
  },
  data: function () {
    return {
      loading: false,
    }
  },
  props: {
    company: {
      type: Object,
      required: true
    },
    companyApiInfoPropertyName: {
      type: String,
      required: true
    },
    serviceName: {
      type: String,
      required: true
    }
  },
  computed: {
    companyApiKeyValidatedTextValue() {
      return utils.getCompanyApiKeyValidatedTextValue(this.company[this.companyApiInfoPropertyName].validated)
    },
    companyApiKeyValidatedColor() {
      switch (this.company[this.companyApiInfoPropertyName].validated) {
        case 0:
          return "orange";
        case 1:
          return "red";
        case 2:
          return "green";
        default:
          return "grey";
      }
    }
  },
  methods: {
    updateParentComponent() {
      this.$emit('updateCompany', this.company.id);
    }
  }
}
</script>
